import { SELECT_YOUR_X_DROPDOWN_TOGGLE } from './actionTypes';

export function selectYourXDropdownToggle(dropdownIndex) {
    return {type: SELECT_YOUR_X_DROPDOWN_TOGGLE, dropdownIndex };
}